
export const initialValues = {
  designationCode: "",
  designationName: "",
  departmentId: "",
  desGradeId: "",
  activeStatus: 1,

}